import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  height: 222px;
  width: 100%;
  overflow: hidden;
  padding: 9px 32px 9px 17px;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  margin-bottom: 36px;
`;

const Title = styled.div`
  font-style: normal;
  margin: -9px -32px 9px -17px;
  padding-left: 17px;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
  display: flex;
  align-items: center;
  height: 42px;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
  margin-bottom: 15px;
`;

const ChartWrapper = styled.div`
  @media (min-width: 1390px) {
    max-width: 93%;
  }
`;

export default {
  Container,
  Title,
  ChartWrapper,
};
